<div style="width: 100%; text-align:center">
  <h6 style="text-align: center; color: white; font-size: 0.9em">{{message }} <i *ngIf="data.action == 'COMPLETED'"
      class="fas fa-check-circle" style="color: green; font-size: 1.2em"></i>  <i *ngIf="data.action == 'ERROR'"
      class="fas fa-times-circle" style="color: RED; font-size: 1.2em"></i></h6>
</div>